module.exports = __webpack_public_path__ + "img/home_menu_3_default.171ec996.png";